document.addEventListener('DOMContentLoaded', function () {
  var toggle = document.querySelector('.menu-toggle');
  var nav = document.querySelector('#SiteNav');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var isOpen = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!isOpen));
      nav.classList.toggle('is-open', !isOpen);
      document.body.classList.toggle('menu-open', !isOpen);
    });
  }
});
document.addEventListener('DOMContentLoaded', function () {
  const modal = document.querySelector('[data-language-modal]');
  const openButton = document.querySelector('[data-language-open]');

  if (!modal || !openButton) {
    console.warn('Language selector: required elements not found.');
    return;
  }

  // Open the language popup
  openButton.addEventListener('click', function () {
    modal.hidden = false;
  });

  // Close the popup
  modal.querySelectorAll('[data-language-close]').forEach(function (button) {
    button.addEventListener('click', function () {
      modal.hidden = true;
    });
  });

  // Close with Escape
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && !modal.hidden) {
      modal.hidden = true;
    }
  });

  // Switch language
  modal.querySelectorAll('[data-language-code]').forEach(function (button) {
    button.addEventListener('click', function () {
      const input = modal.closest('form')?.querySelector('[data-language-input]');

      if (!input || !input.form) return;

      input.value = button.dataset.languageCode;
      input.form.submit();
    });
  });
});
